import * as nodeEmoji from 'node-emoji';

/**
 * Slack emoji names that node-emoji doesn't cover or maps differently.
 * Keys are the Slack short-name (base, no skin-tone suffix).
 */
const SLACK_FALLBACK: Record<string, string> = {
  rolling_on_the_floor_laughing: '🤣',
  rofl: '🤣',
  face_with_diagonal_mouth: '😮‍💨',
  face_with_raised_eyebrow: '🤨',
  face_with_symbols_on_mouth: '🤬',
  exploding_head: '🤯',
  zany_face: '🤪',
  shushing_face: '🤫',
  pleading_face: '🥺',
  slightly_smiling_face: '�',
  upside_down_face: '�',
  star_struck: '🤩',
  melting_face: '🫠',
  saluting_face: '🫡',
  dotted_line_face: '🫥',
  heart_hands: '🫶',
  handshake: '🤝',
  pinched_fingers: '🤌',
  index_pointing_at_the_viewer: '🫵',
  // Coloured circles — Slack uses "large_X_circle"; node-emoji uses "X_circle" or lacks them
  large_red_circle: '🔴',
  large_orange_circle: '🟠',
  large_yellow_circle: '🟡',
  large_green_circle: '🟢',
  large_blue_circle: '🔵',
  large_purple_circle: '🟣',
  large_brown_circle: '🟤',
  large_white_circle: '⚪',
  large_black_circle: '⚫',
  // Coloured squares
  red_square: '🟥',
  orange_square: '🟧',
  yellow_square: '🟨',
  green_square: '🟩',
  blue_square: '🟦',
  purple_square: '🟪',
  brown_square: '🟫',
};

/**
 * Convert a Slack/Discord emoji short-name to its Unicode character.
 * Handles skin-tone variants: "-1::skin-tone-3" → "👎"
 * Falls back to `:name:` if not found in any dictionary.
 */
export function toEmoji(name: string): string {
  const clean = name.replace(/^:|:$/g, ''); // strip surrounding colons
  const base = clean.split('::')[0];        // strip ::skin-tone-N suffix

  // 1. Direct node-emoji lookup on base name
  const result = nodeEmoji.get(base);
  if (result && !result.includes('undefined')) return result;

  // 2. Fallback map for Slack-specific names
  if (SLACK_FALLBACK[base]) return SLACK_FALLBACK[base];

  // 3. Try node-emoji with original clean name
  const full = nodeEmoji.get(clean);
  if (full && !full.includes('undefined')) return full;

  return `:${base}:`;
}
